import { array, date, number, object, string } from 'yup';

const invoiceItemSchema = object().shape({
    itemableId: number().strict().min(1).required(),
    itemableType: string().min(3).required(),
    quantity: number().strict().min(1).required(),
    description: string().min(3).optional(),
});

const invoicePaymentSchema = object().shape({
    amount: number().strict().min(0.01).required(),
    gatewayId: number().strict().min(1).required(),
    currency: string().length(3).required(),
    exchangeRate: number().strict().min(1).required(),
    date: string().required(),
});

const purchaseFormSchema = object().shape({
    userId: number().strict().min(1).required(),
    planId: number().strict().min(1).required(),
    from: date().required(),

    invoice: object()
        .shape({
            items: array().of(invoiceItemSchema).required(),
            payments: array().of(invoicePaymentSchema).required(),
        })
        .required(),

    reason: string().min(3).required(),
});

export { purchaseFormSchema };
